import type { AclosetHttpClient } from './AclosetHttpClient';
import { SwaggerApi } from './Swagger';

export class AclosetApiWrapper extends SwaggerApi<void> {
  constructor(http: AclosetHttpClient) {
    super(http);
  }
}
